import { render, staticRenderFns } from "./cost-info.vue?vue&type=template&id=5d3394be&scoped=true&"
import script from "./cost-info.vue?vue&type=script&lang=js&"
export * from "./cost-info.vue?vue&type=script&lang=js&"
import style0 from "./cost-info.vue?vue&type=style&index=0&id=5d3394be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3394be",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fquake%2Fworkspace%2Fauction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Forders%2Fcomponents%2Fcost-info.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports